export default __webpack_public_path__ + "static/media/collapseArrow.e24cfafd.svg";